// import CustomSelect from "components/common/CustomSelect";
import CustomizedMenus from '../../../../../components/common/CustomSelect/index';
import { Button as CustomButton, BUTTON } from 'components/common/Button/Button';
import { Paper, InputBase } from '@material-ui/core';
import styles from './styles.scss';
import { Fragment, memo } from 'react';

function SelectDataSource({
    dataSources,
    handleSelectedDataSource, handleCreateDataSource,
    canAddDataSource, selectedDataSource, dataSourceError, errors, delegationDisclaimers
}) {
    const errorMessage = delegationDisclaimers ? delegationDisclaimers.DataSource.existingDataSource : '';
    return (
        <CustomizedMenus
            label="Data Source"
            placeholder="Data Source"
            options={dataSources}
            isRequired={true}
            buttonLabel={'Create'}
            onSelectedOption={handleSelectedDataSource}
            onButtonClicked={handleCreateDataSource}
            value={selectedDataSource}
            notValid={dataSourceError}
            renderChild={(props) => (
                <section>
                    <div>
                        <ul>
                            {
                                props.filteredOptions.map((el, index) => (
                                    <li className={styles.ListItems} style={{ backgroundColor: `${el.value === selectedDataSource && '#2684FF'}`, color: `${el.value === selectedDataSource && '#FFF'}` }} onClick={() => props.handleOptionSelected(el.value)} key={`${index * Math.random()}_${el.label}}`}>{el.text || el.label}</li>
                                ))
                            }
                        </ul>
                        {canAddDataSource && (
                            <Fragment>
                                <Paper square elevation={0} className={styles.CreateSection}>
                                    <InputBase
                                        className={{
                                            [styles.input]: true,
                                            [styles.invalidInput]: (errors && errors.duplicatedDataSource)
                                        }}
                                        onChange={props.handleNewDataSource}
                                        onKeyDown={(e) => e.stopPropagation()}
                                        value={props.newDataSource}
                                        placeholder='New Data Source'
                                        inputProps={{
                                            'aria-label': 'create data source', style: {
                                                fontSize: '16px', fontFamily: 'Hind',
                                                fontWeight: '400',
                                                fontStyle: 'normal',
                                                lineHeight: '18px',
                                                padding: '0.5px'
                                            }
                                        }}
                                    />
                                    <CustomButton
                                        bgcolor={BUTTON.BGCOLOR.BLUE}
                                        color={BUTTON.COLOR.WHITE}
                                        onClick={props.handleOnClick}
                                    >Create</CustomButton>
                                </Paper>
                                {(errorMessage && errors && errors.duplicatedDataSource) && (<pre className={styles.errorMessage}>{errorMessage}</pre>)}
                            </Fragment>
                        )}
                    </div>

                </section>
            )}
        />
    );
}

export default memo(SelectDataSource);